import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
export function CateringPage() {
  return <div className="bg-white" data-id="element-593">
      <PageHero title="Commissary & Catering" subtitle="Large-scale culinary operations delivering consistent quality for off-site events." backgroundImage="https://images.unsplash.com/photo-1555244162-803834f70033?w=1920&q=80" data-id="element-594" />

      <section className="py-24 md:py-32" data-id="element-595">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-596">
          <div className="text-center mb-20" data-id="element-597">
            <motion.h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-598">
              Service Options
            </motion.h2>
            <motion.div className="w-16 h-1 bg-brand-red mx-auto" initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} data-id="element-599" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-32" data-id="element-600">
            {[{
            title: 'Weddings',
            img: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80'
          }, {
            title: 'Corporate Events',
            img: 'https://images.unsplash.com/photo-1505366518450-2824e55d154e?w=600&q=80'
          }, {
            title: 'Private Parties',
            img: 'https://images.unsplash.com/photo-1530103862676-de8892b07439?w=600&q=80'
          }].map((service, idx) => <motion.div key={idx} className="group relative overflow-hidden rounded-sm aspect-[4/5]" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-601">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-602" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/90 via-brand-dark/20 to-transparent" data-id="element-603"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-604">
                  <h3 className="text-2xl font-serif text-white" data-id="element-605">
                    {service.title}
                  </h3>
                </div>
              </motion.div>)}
          </div>

          {/* Quote Form */}
          <motion.div className="bg-brand-beige p-10 md:p-16 rounded-sm relative overflow-hidden max-w-4xl mx-auto" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-606">
            <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-607"></div>
            <div className="relative z-10" data-id="element-608">
              <div className="text-center mb-12" data-id="element-609">
                <h3 className="text-3xl font-serif text-brand-dark mb-4" data-id="element-610">
                  Request a Quote
                </h3>
                <p className="text-brand-dark/60 font-light" data-id="element-611">
                  Let us bring the JJ Group culinary experience to your next
                  event.
                </p>
              </div>

              <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-612">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-613">
                  <div data-id="element-614">
                    <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-615">
                      Name / Company
                    </label>
                    <input type="text" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors" data-id="element-616" />
                  </div>
                  <div data-id="element-617">
                    <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-618">
                      Email Address
                    </label>
                    <input type="email" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors" data-id="element-619" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-620">
                  <div data-id="element-621">
                    <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-622">
                      Event Date
                    </label>
                    <input type="date" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors text-brand-dark" data-id="element-623" />
                  </div>
                  <div data-id="element-624">
                    <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-625">
                      Estimated Guests
                    </label>
                    <input type="number" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors" data-id="element-626" />
                  </div>
                </div>
                <div data-id="element-627">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-628">
                    Event Details & Menu Preferences
                  </label>
                  <textarea rows={4} className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors resize-none" data-id="element-629"></textarea>
                </div>
                <button className="w-full bg-brand-dark text-white py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-brand-red transition-colors mt-4" data-id="element-630">
                  Submit Request
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}